import Vue from 'vue';
import VueRouter from 'vue-router';

import Home from '@/views/Home';
import Login from '@/views/Login';
import creation from './creation';
import Layout from '../layout';
import charts from './charts';
import activity from './activity';
import income from './income';
import account from './account';
import studioManager from './studioManager';
import studioMember from './studioMember';
import studioVipManager from './studioVipManager';
import studioVipMember from './studioVipMembers';
import studioCreator from './studioCreator';
import cloudServer from './cloudServer';
import actConf from './actConf';
import publishAct from './publishAct';
Vue.use(VueRouter);

// 固定路由
export const constantRoutes = () => [
  // 首页
  {
    path: '/',
    redirect: '/home',
    component: Layout,
    meta: {
      title: '首页',
      icon: 'icon-home',
      activePath: 'home',
    },
    children: [
      {
        path: 'home',
        name: 'Home',
        component: Home,
      },
    ],
  },

  {
    path: '/login',
    name: 'Login',
    component: Login,
    hidden: true,
  },
  {
    path: '/Certify/:uin',
    name: 'Certify',
    component: () => import('@/views/Certify.vue'),
    hidden: true,
  },
  // 数据中心
  ...charts,
  // 收益管理
  ...income,
  //活动赛事
  ...activity,

  //创作灵感
  ...creation,
  // 发布活动
  ...publishAct,

  // 云服
  // ...cloudServer, // TODO 临时注释
  // 兑换商城
  // ...exchangeShop,
  // 活动配置
  // ...actConf,
  // 账号管理
  ...account,
  // 工作室
  // ...studio,

  // 404
  {
    path: '/404',
    component: () => import('../views/404'),
    hidden: true,
  },
  // { path: '*', redirect: '/404', hidden: true },
];

// 动态路由 - 目前的缺点：只控制了大模块，没有控制细分的子孙路由
export const asyncRoutes = [...income];
export const asyncRoutes4Manager = [...studioManager];
export const asyncRoutes4Member = [...studioMember];
export const asyncRoutes4VipManager = [...studioVipManager];
export const asyncRoutes4VipMember = [...studioVipMember];
export const asyncRoutes4Creator = [...studioCreator];
// TODO 临时代码
export const asyncCloudRoutes = [...cloudServer];
export const asyncCloudRoutesNameList = ['cloudserver'];
export const asyncActConfRoutes = [...actConf];
export const asyncActConfRoutesNameList = ['actConf'];

// 动态路由名单
export const asyncRouteNameList = ['Income'];
export const asyncRoute4ManagerNameList = ['StudioManager'];
export const asyncRoute4MemberNameList = ['StudioMember'];
export const asyncRoute4VipMemberNameList = ['StudioVipMember'];
export const asyncRoute4VipManagerNameList = ['StudioVipManager'];
export const asyncRoute4CreatorNameList = ['StudioCreator'];

// 公共路由
export const publicRoutes = [{ path: '*', redirect: '/404', hidden: true }];

const createRouter = () =>
  new VueRouter({
    routes: constantRoutes(),
    scrollBehavior: () => ({ y: 0 }),
  });

const router = createRouter();

export function resetRouter() {
  const newRouter = createRouter();
  router.matcher = newRouter.matcher;
}

export default router;
